import React from 'react';
import { ModalWrapper } from './styles';
import { Divider, ModalFuncProps } from 'antd';

type TModalCustomProps = ModalFuncProps & {
  children: React.ReactNode;
  resetPaddingModal?: boolean;
  confirmLoading?: boolean;
};

const ModalCustom = ({
  children,
  className,
  resetPaddingModal,
  width,
  confirmLoading,
  ...props
}: TModalCustomProps) => {
  return (
    <ModalWrapper
      className={`${className || ''} ${resetPaddingModal ? 'reset-padding-body' : ''}`}
      width={width}
      maskClosable={false}
      destroyOnClose
      confirmLoading={confirmLoading}
      {...props}
    >
      {resetPaddingModal && <Divider className="m-0" />}
      {children}
    </ModalWrapper>
  );
};

export default ModalCustom;
